// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"126":"[auth]","285":"[Home]","631":"[profile]"}[chunkId] || chunkId) + "." + {"56":"2c4699f2","126":"89a61a84","285":"628e9b99","387":"d2dcdc00","411":"e0e699e7","631":"5d05a84d","787":"4a21b8e5","996":"ba5f61df"}[chunkId] + ".chunk.js";
};